/**
 * 發票類型配置
 */
export const INVOICE_ISSUING_TYPE_OPTIONS = [
	{
		text: "二聯式發票",
		value: 2,
		shortText: "二聯式",
	},
	{
		text: "三聯式發票",
		value: 3,
		shortText: "三聯式",
	},
];

/**
 * 載具類型配置
 */
export const INVOICE_CARRIER_TYPE_OPTIONS = [
	{
		text: "會員載具",
		value: 1,
	},
	{
		text: "手機載具",
		value: 2,
	},
	{
		text: "自然人憑證",
		value: 3,
	},
];

/**
 * 彈窗名字常量
 */
export const DIALOG_NAMES = {
	PRODUCT_ADDED_CONFIRM: "ProductAddedConfirmDialog",
	PRODUCT_SCAN: "ProductScanDialog",
	MEMBER_SCAN: "MemberScanDialog",
	INVOICE_SETTING: "InvoiceSettingDialog",
	PRODUCT_SETTING: "ProductSettingDialog",
	CHECKOUT_COMPLETE: "CheckoutCompleteDialog",
};

/**
 * 白名單：這些彈窗打開時，仍然可以使用 useGlobalBarcodeScanner
 */
export const BARCODE_SCANNER_WHITELIST = new Set([DIALOG_NAMES.PRODUCT_ADDED_CONFIRM]);